import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Receipt, FilePdf } from '@phosphor-icons/react';

export function AdminInvoicesTab({ invoices, invoicesTotal, downloadInvoice }) {
  return (
    <div className="space-y-3" data-testid="invoices-tab">
      {invoices.length === 0 ? (
        <Card className="border border-dashed">
          <CardContent className="p-8 text-center">
            <Receipt size={32} className="mx-auto text-gray-300 mb-2" />
            <p className="text-sm text-[#6B7280]">Aucune facture pour le moment</p>
            <p className="text-xs text-[#9CA3AF] mt-1">Les factures apparaitront ici apres le premier paiement.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-2">
          <div className="flex items-center gap-4 text-xs text-[#6B7280] mb-2">
            <span className="font-bold text-[#111827]">{invoices.length} facture(s)</span>
            <span>Total : <strong className="text-[#FF6B00]">{invoicesTotal} EUR</strong></span>
          </div>
          {invoices.map(inv => (
            <Card key={inv.id} className="border" data-testid={`admin-invoice-${inv.id}`}>
              <CardContent className="p-3 sm:p-4 flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-9 h-9 rounded-lg bg-orange-50 flex items-center justify-center flex-shrink-0">
                    <Receipt size={18} className="text-[#FF6B00]" />
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-bold text-[#111827] truncate">{inv.invoice_number}</p>
                    <p className="text-xs text-[#6B7280] truncate">
                      {inv.user_name || inv.user_email} - {inv.plan_name} - {new Date(inv.created_at).toLocaleDateString('fr-FR')}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-sm font-black text-[#111827]">{inv.amount} <span className="text-xs font-medium text-[#9CA3AF]">EUR</span></span>
                  <Button variant="outline" size="sm"
                    onClick={() => downloadInvoice(inv.id, inv.invoice_number)}
                    className="h-9 text-[#FF6B00]" data-testid={`dl-invoice-${inv.id}`}>
                    <FilePdf size={16} className="mr-1" /> PDF
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
